
import AgentSignupForm from '@/modules/auth/components/agent/agent-signup-form.component.vue'
import { IAgentSignup, LocalizationPath } from '@tokyojob/core'
import Vue from 'vue'

import { getLocalization } from '@tokyojob/frontend-components'
import { AgentSignupMetaFactory, IHead, LocalizationService } from '@tokyojob/frontend-core'
import AgentSignupUseCase from '~/modules/auth/usecases/agent-signup.usecase'

export default Vue.extend({
  layout: 'agent/auth',
  components: { AgentSignupForm },
  data() {
    return {
      error: false
    }
  },
  methods: {
    async submit(props: IAgentSignup) {
      const usecase = new AgentSignupUseCase(this.App)
      const res = await usecase.execute(props)

      if (res) {
        setTimeout(() => {
          // No access to the redirect function,
          // this will only happen on the client side so for now I am using
          // the window
          if (window) {
            const wnd = window as any
            wnd.location.href = '/agent'
          } else {
            this.$router.push(`/auth/register-success?type=agent`)
          }
        }, 1000)
      } else {
        this.error = true
      }
    }
  },
  head(): IHead {
    const localization = getLocalization(this.App)
    const title = LocalizationService.t<string>(localization, LocalizationPath.AgentSignupPageMetaTagTitle)
    const meta = AgentSignupMetaFactory.metaTags(localization, this.App.localizationSelector.languageLocale)
    return { title, meta }
  }
})
